import { FLUTTER_IFRAME_WRAPPER_MAP } from './../../flutter/flutter.consts.js';
import { resizeFrame, isDesktop, getStateAbbreviationFromURLPath, addLoadingSpinner, removeLoadingSpinner, sendToGa4 } from './../../flutter/flutter.utils.js';
// FlutterCheckout.js
export default class FlutterCheckout {

  constructor() {
    if (process.env.NODE_ENV === 'development') {
      console.log('flutter.checkout: initializing');
    }
    this.loadDependencies().then(() => {
      this.initializeProperties();
      if (this.$wrapper.length >= 1) {
        this.initializeCheckoutWidget();
        addLoadingSpinner(this.$wrapper);
        if (this.debugMode) {
          console.log('flutter.checkout: initialized');
        }
      }
    });
  }

  async loadDependencies() {

    const moment = await import('moment')
    this.moment = moment.default;
    await Promise.all([
      import(/* webpackMode: "eager" */ './flutter-checkout.scss'),
      import(/* webpackMode: "eager" */ '../../scripts/dbs/dbs.utilities.querystring'),
      import(/* webpackMode: "eager" */ '../../plugins/semantic/modal'),
      import(/* webpackMode: "eager" */ '../../plugins/semantic/modal.scss'),
    ]);
  }

  initializeProperties() {
    this.queryString = new dbs.utilities.querystring()
    this.$wrapper = $(FLUTTER_IFRAME_WRAPPER_MAP['checkout'])
    this.$preview_pane_dimmer = $("#flutter_preview_pane_dimmer")
    this.$confirmation_popup = $("#flutter_confirmation_popup")
    this.$confirmation_cancel = $("#confirmation_cancel")
    this.$confirmation_continue = $("#confirmation_continue")
    this.$confirmationContent = $('#checkout_confirmation_widget_area')
    this.$iframeSourceUrl = $('#flutter_checkout_iframe_source_url')

    // Terms and conditions popup modal
    this.popup_modal;
    this.popup_ModalTemplate = `
    <div id="flutter_terms_popup" class="ui modal small  scrolling transition hidden" style="display: none;">
      <div class="content">
        <h2 class="terms-title">
          Booking Terms & Conditions
          <i class="close icon icon-close flutter-terms-close-button"></i>
        </h2>
        <hr>
        <div class="terms-content"></div>
        <hr class="bottom-hr">
        <div class="close-button-tab-container">
          <button class="ui button tab-close-button flutter-terms-close-button">Close</button>
        </div>
      </div>
    </div>`

    this.localDebugEnabled = true;
    this.debugMode == this.localDebugEnabled && process.env.NODE_ENV === 'development';
    this.isFirstLoad = true;
  }



  initializeListeners() {
    const self = this;
    // Setup confirmation cancel button
    self.$confirmation_cancel.on('click', function () {
      self.$confirmation_popup.removeClass('active');
      self.$preview_pane_dimmer.removeClass('active')
      $("body").removeClass('no-scroll');
    });

    // Setup confirmation continue button
    self.$confirmation_continue.on('click', function () {
      // Possibly handle removing window/back button listeners here
      var redirectUrl = self.$confirmation_popup.attr('data-redirect-url')
      window.location = redirectUrl;
    });

    $('body').on('click', '.flutter-terms-close-button', function (e) {
      self.popup_modal.modal('hide');
    });

    // Setup preview pane dimmer click events
    self.$preview_pane_dimmer.off('click').on('click', function () {
      self.closeConfirmationDialog();
    });

    // Setup "click away" event when clicking on a link to leave the checkout page
    // Binds
    self.handleClickAway = self.handleClickAwayEvent.bind(this);
    // Add the event listener
    self.setupClickAwayListener();
  }

  setupClickAwayListener() {
    const self = this;
    document.addEventListener('click', self.handleClickAway);
  }

  removeClickAwayListener() {
    const self = this;
    document.removeEventListener('click', self.handleClickAway);
  }

  handleClickAwayEvent(e) {
    const self = this;
    let anchor = e.target.closest('a');
    if (anchor && anchor.href) {
      e.preventDefault();
      self.showConfirmationDialog({
        'message': "Are you sure you want to leave this page?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
        'subtext': 'Your changes may not be saved if you leave',
        'primaryButton': "Yes, Leave",
        'redirectUrl': anchor.href
      });

    }
  }

  initializeCheckoutWidget() {
    const self = this;
    // Setup preview pane dimmer click events

    $('body').append(self.popup_ModalTemplate);
    self.popup_modal = $("#flutter_terms_popup");
    self.popup_modal.modal({
      closable: true,
    });

    const currentStep = self.queryString.getParameter('step');
    if (currentStep != null) {
      switch (currentStep) {
        case "3":
          self.$confirmationContent.show();
          break;
        default:
          // TODO handle other steps when we can
          break;
      }
    }

    self.initializeListeners();
  }


  // handleTermsAndConditionsPopup - Handles the terms and conditions popup
  // @param {object} eventData - The event data
  // @returns {void}
  handleTermsAndConditionsPopup(eventData) {
    // Show the conditions popup
    const self = this;
    // This can probably be removed in prod, but it works around things for now
    if (eventData.includes('/TEST')) {
      //eventData.replace('/TEST', '/SADE');
    }
    const domain = window.location.host;
    let apiUrl = eventData;
    if (!eventData.includes(domain)) {
      // it's probably a production URL, so lets replace it
      let dataArr = eventData.split('/')
      let parkCode = dataArr[dataArr.length - 1]
      apiUrl = window.location.origin + "/api/terms-and-conditions/" + parkCode
    }

    //
    $.ajax({
      url: apiUrl,
      type: 'GET',
    })
      .done(function (response) {
        self.showTermsAndConditionsPopup(response);
      })
      .always(function () { })
  }

  showTermsAndConditionsPopup(html) {
    const self = this;
    self.popup_modal.children('.content').children('.terms-content').html(html);
    self.popup_modal.show();
    self.popup_modal.modal('show')
    const checkContentLoaded = setInterval(function () {
      const flutterId = $('#flutter_terms_popup .content');
      if (flutterId.length > 0) {
        clearInterval(checkContentLoaded);
        self.scrollToTopOfFlutter(flutterId);
      }
    }, 500);

  }

  scrollToTopOfFlutter(flutterId) {
    flutterId.parents('.transition').animate({
      scrollTop: 0,
    });
  }


  // handleCheckoutRedirectEvent - Handles the checkout redirect event
  // @param {object} eventData - The event data
  // @param {object} popupParams - The parameters for the popup
  // @returns {void}
  handleCheckoutRedirectEvent(eventData, popupParams) {
    const self = this;

    // This is emitted every time a page changes, if we want to handle URL history / tracking via the browser URL we can do that here
    let data = null;
    popupParams.redirectUrl = "/";

    if (eventData && typeof eventData === 'object') {
      if (eventData.hasOwnProperty('parkCode')) {
        data = eventData;
      } else if (eventData.hasOwnProperty('bookingContext')) {
        data = eventData.bookingContext;
      }
    } else {
      //forcing a redirect while hiding the cancel popup
      console.error('Invalid eventData:', eventData);
      $('#flutter_confirmation_popup').addClass('inactive');
      window.location.href = window.location.origin;

    }

    if (data != null) {
      popupParams.redirectUrl = "/jaqredirect?"
        + "parkCode=" + data.parkCode
        + '&arrive=' + self.moment(data.arriveOn).format('YYYY-MM-DD')
        + '&depart=' + self.moment(data.departOn).format('YYYY-MM-DD')
        + '&adults=' + (parseInt(data.totalAdults) >= 0 ? parseInt(data.totalAdults) : 2)
        + '&kids=' + (parseInt(data.totalKids) >= 0 ? parseInt(data.totalKids) : 0)
        + '&infants=' + (parseInt(data.totalInfants) >= 0 ? parseInt(data.totalInfants) : 0)
        + '&nonce=' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

      if (data.hasOwnProperty('serviceDefinitionId')) {
        popupParams.redirectUrl += '&accommodationRoomId=' + data.serviceDefinitionId
      }
      if (data.dealPromoCode != null && data.dealCode != "") {
        popupParams.redirectUrl += '&dealCode=' + data.dealPromoCode;
      }
      if (data.hasOwnProperty('openPreviewWindow')) {
        popupParams.redirectUrl += '&openPreviewWindow=true'
      }
    }
    self.showConfirmationDialog(popupParams);
  }

  // handleCheckoutStateEvent - Handles the checkout state event
  // @param {object} eventData - The event data
  // @returns {void}
  handleCheckoutStateEvent(eventData) {
    const self = this;
    if ($(window).scrollTop() > 0) {
      // Smooth scroll
      $('html, body').animate({ scrollTop: 0 }, 500);

    }

    switch (eventData.step) {
      case -1:
        self.updateUrlWithStep(-1)
        break;
      case 0:
        self.updateUrlWithStep(0)
        break;
      case 1:
        self.updateUrlWithStep(1)
        break;
      case 2:
        self.updateUrlWithStep(2)
        break;
      case 3:
        debugger;
        self.updateUrlWithStep(3)
        self.removeListenersFromConfirmationPage();
        // Show the success widget area above the checkout widget
        self.$confirmationContent.show(250);
        $('html, body').animate({
          scrollTop: 0
        }, 500);
        break;
    }
    // Push &step=x to the URL to the browser history without reloading

  }

  removeListenersFromConfirmationPage() {
    const self = this;
    self.removeClickAwayListener();

  }

  updateUrlWithStep(step) {
    const url = new URL(window.location.href);
    url.searchParams.set('step', step);
    window.history.pushState({}, '', url);

    //let iFrameUrl = new URL(self.$iframeSourceUrl.attr('src'));
    //if (!bookingUrl.searchParams.has('step')) {
      //iFrameUrl.searchParams.append('step', step);
    //}
    //else {
      //iFrameUrl.searchParams.set('step', step);
    //}
    //self.$iframeSourceUrl.src = iFrameUrl.href;
  }

  handleEvent(eventType, eventData) {
    const self = this;
    if (self.debugMode) {
      console.log('flutter.checkout: handleEvent', eventType, eventData);
    }
    if (self.isFirstLoad) {
      self.$wrapper.find('iframe').height(self.$wrapper.height() + 1);
      removeLoadingSpinner(self.$wrapper);
      self.isFirstLoad = false;
    }
    debugger;

    switch (eventType) {
      case 'onResize':
        resizeFrame(self.$wrapper, eventData.width, eventData.height, 850, 70); // 850 min height might be too aggressive
        break;
      case 'ga4Event':
        sendToGa4(eventData);
        break;
      case 'checkout':
        self.handleCheckoutStateEvent(eventData);
        break;
      case 'cancelCheckout':
        self.handleCheckoutRedirectEvent(eventData, {
          'message': "Are you sure you want to cancel?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
          'subtext': 'Cancelling will take you back to accommodation search',
          'primaryButton': "Yes, Cancel"
        });
        break;
      case 'deleteBooking':
        break;
      case 'editBooking':
        eventData.bookingContext.openPreviewWindow = true // Used to notify the park page that it will be opening the preview pane
        self.handleCheckoutRedirectEvent(eventData, {
          'message': "Are you sure you want to update these booking details?",
          'subtext': 'Updating these details will take you back to the previous screen',
          'primaryButton': "Yes, Update"
        })
        break;
      case 'viewAccommodationInfo':
        //"{\"accommodationCode\":\"TEST-1-3-RT\",\"parkCode\":\"TEST\"}"
        const redirectUrl = "/jaqredirect?"
          + "parkCode=" + eventData.parkCode
          + '&accommodationCode=' + eventData.accommodationCode // the parameter accommodationCode could be used in place of accommodationRoomId if we wanted it to redirect to the single accommodation page
        if (self.debugMode) {
          debugger;
          console.log('flutter.checkout: viewAccommodationInfo: redirecting', eventData, redirectUrl);
        }
        window.location = redirectUrl;
        break;
      case 'viewAvailability':
        debugger;
        break;
      case 'viewTermsAndConditions':
        self.handleTermsAndConditionsPopup(eventData)
        break;
      case 'redirect':
        window.open(window.location.origin + eventData, '_blank');
        break;
      case 'viewPark':
        console.log('handles viewPark event')
        window.location = window.location.origin + '/parks'
        break;
      default:
        if (self.debugMode) {
          console.warn('flutter.deals: unhandled event', eventType, eventData);
        }
        break;
    }
  }


  // closePopup - Closes the confirmation popup
  // @returns {void}
  closeConfirmationDialog() {
    const self = this;
    self.$preview_pane_dimmer.click(function () {
      if (self.$confirmation_popup.hasClass('active')) {
        self.$confirmation_popup.removeClass('active');
        self.$preview_pane_dimmer.removeClass('active');
      }
    })
  }

  // showConfirmationDialog - Shows a confirmation dialog
  // @param {object} params - The parameters for the dialog
  // @returns {void}
  showConfirmationDialog(params) {
    const self = this;
    if (params.hasOwnProperty('message') && params.hasOwnProperty('subtext') && params.hasOwnProperty('primaryButton') && params.hasOwnProperty('redirectUrl')) {
      self.$confirmation_popup.find('.message-text').html(params.message);
      self.$confirmation_popup.find('.subtext').text(params.subtext);
      self.$confirmation_popup.find('a.primary').text(params.primaryButton);
      self.$confirmation_popup.removeAttr('style').attr('data-redirect-url', params.redirectUrl);
      $('body').addClass('no-scroll');
      self.$confirmation_popup.toggleClass('active');
    } else {
      console.error('flutter.checkout: showConfirmationDialog: Missing required parameters', params);
    }

  }

}
